import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/auth.service";
import { filter, firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class AnonGuard {
    constructor(
        private readonly _router: Router,
        private readonly _authService: AuthService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        await firstValueFrom(this._authService.checkAuthStatusComplete$.pipe(
            filter(v => v === true),
        ));
        if (this._authService.user) {
            return this._router.createUrlTree(["/"]);
        } else {
            return true;
        }
    }
}
